'use client'

import { useEffect, useState, useCallback } from 'react'
import { IoChevronUp } from 'react-icons/io5'

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)

  const handleScroll = useCallback(() => {
    const nextVisible =
      (window.pageYOffset || document.documentElement.scrollTop) > 320
    setIsVisible((current) => (current === nextVisible ? current : nextVisible))
  }, [])

  useEffect(() => {
    handleScroll()

    let ticking = false
    const onScroll = () => {
      if (ticking) {
        return
      }

      ticking = true
      window.requestAnimationFrame(() => {
        handleScroll()
        ticking = false
      })
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [handleScroll])

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      scrollToTop()
    }
  }, [scrollToTop])

  return (
    <button
      aria-label="Scroll to top"
      onClick={scrollToTop}
      onKeyDown={handleKeyDown}
      className={`
        fixed z-[999] 
        bottom-[64px] md:bottom-8
        right-8
        w-10 h-10 md:w-11 md:h-11
        border border-link-blue bg-bg-dark 
        rounded-full 
        flex items-center justify-center
        cursor-pointer
        outline-none
        focus:ring-2 focus:ring-link-blue focus:ring-offset-2 focus:ring-offset-bg-dark
        ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none'}
      `}
      style={{ transition: 'opacity 0.2s ease, transform 0.2s ease' }}
    >
      <IoChevronUp className="h-5 w-5 md:h-6 md:w-6 text-link-blue" />
    </button>
  )
}
